import CircularProgress from "@mui/material/CircularProgress";

const LoadingPage = () => {
  return (
    <div className="flex w-full h-screen items-center justify-center">
      <CircularProgress color="inherit" className="text-tgpt-secondary-main" />
    </div>
  );
};

export default LoadingPage;
